import { render, staticRenderFns } from "./RefreshBtn.vue?vue&type=template&id=2f7ecd1f&"
import script from "./RefreshBtn.vue?vue&type=script&lang=ts&"
export * from "./RefreshBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
